// =====================================================================
// AccountEntryDialog (Financeiro Tesouraria / S63) — lançamento manual no
// extrato de uma conta (crédito = entrada / débito = saída). Para ajustes,
// aportes, tarifas etc. que não vêm de pagamento/despesa.
// =====================================================================
import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, CircularProgress
} from "@material-ui/core";
import { toast } from "react-toastify";
import { createAccountEntry, financeErrorMessage } from "../../services/financeService";
import useIsMobile from "../../utils/useIsMobile";

const AccountEntryDialog = ({ open, accounts, accountId, onClose, onSaved }) => {
  const isMobile = useIsMobile();
  const active = (accounts || []).filter((a) => a.active);
  const [acc, setAcc] = useState("");
  const [type, setType] = useState("credito");
  const [amount, setAmount] = useState("");
  const [entryDate, setEntryDate] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setAcc(accountId ? String(accountId) : (active[0] ? String(active[0].id) : ""));
      setType("credito"); setAmount(""); setEntryDate(""); setDescription(""); setCategory("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, accountId]);

  const handleSave = async () => {
    if (!acc) { toast.error("Selecione a conta."); return; }
    const value = Number(String(amount).replace(",", "."));
    if (!value || value <= 0) { toast.error("Informe um valor válido."); return; }
    setSaving(true);
    try {
      await createAccountEntry({
        accountId: Number(acc), type, amount: value,
        entryDate: entryDate || undefined,
        description: description || undefined,
        category: category || undefined
      });
      toast.success("Lançamento registrado.");
      onSaved && onSaved();
    } catch (err) {
      toast.error(financeErrorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth fullScreen={isMobile}>
      <DialogTitle>Lançamento manual</DialogTitle>
      <DialogContent>
        <TextField select label="Conta" value={acc} onChange={(e) => setAcc(e.target.value)} fullWidth margin="dense">
          {active.map((a) => <MenuItem key={a.id} value={String(a.id)}>{a.name}</MenuItem>)}
        </TextField>
        <TextField select label="Tipo" value={type} onChange={(e) => setType(e.target.value)} fullWidth margin="dense">
          <MenuItem value="credito">Crédito (entrada)</MenuItem>
          <MenuItem value="debito">Débito (saída)</MenuItem>
        </TextField>
        <TextField label="Valor (R$)" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} fullWidth margin="dense" inputProps={{ step: "0.01", min: "0" }} />
        <TextField label="Data" type="date" value={entryDate} onChange={(e) => setEntryDate(e.target.value)} fullWidth margin="dense" InputLabelProps={{ shrink: true }} helperText="Em branco = hoje." />
        <TextField label="Descrição" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth margin="dense" />
        <TextField label="Categoria (opcional)" value={category} onChange={(e) => setCategory(e.target.value)} fullWidth margin="dense" />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={saving}
          startIcon={saving ? <CircularProgress size={16} /> : null}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountEntryDialog;
